/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="66.53"
        height="95.58"
        viewBox="0 0 66.53 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M47.77 38.23v6H18.76v-6h29.01z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M44.37 1.06a1.25 1.25 0 0 1 1.25 1.25 12.36 12.36 0 1 1-24.71 0 1.25 1.25 0 1 1 2.5 0 9.86 9.86 0 1 0 19.71 0 1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/><path
          fill="#0e497b"
          d="M23 95.58h-.12L1.09 93.32A1.25 1.25 0 0 1 0 91.79v-.12l17.21-50.41-8.07-31.08a1.27 1.27 0 0 1 .39-1.26l.1-.07L21.9.23a1.21 1.21 0 0 1 .57-.22H43.9a1.2 1.2 0 0 1 .59.15l.13.08 12.27 8.62a1.25 1.25 0 0 1 .52 1.21v.12l-8.09 31.07 17.14 50.41a1.25 1.25 0 0 1-.93 1.63h-.12l-21.79 2.26H23Zm20.4-2.5L63.59 91 46.83 41.71a1.37 1.37 0 0 1-.06-.57V41l7.94-30.61-11.2-7.89H23l-11.22 7.89L19.72 41a1.22 1.22 0 0 1 0 .57v.14L2.94 91l20.16 2.09Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DressIcon';

export default Icon;
